import React from "react";

export default function Content({ handleState, jobOpening }) {
  const listClass =
    "text-sm [&>ul>li>p]:text-sm text-darkGrey/70 [&>ul]:list-disc [&>ul]:pl-4 [&>ul]:flex [&>ul]:flex-col [&>ul]:gap-2";
  return (
    <div className="flex flex-col w-full lg:h-screen">
      <div className="flex flex-col md:flex-row md:justify-between justify-center items-start w-full lg:mt-10 mt-8 border-b-[0.5px] border-darkGrey/50 pb-10">
        <div
          className="text-sm text-darkGrey/70 lg:max-w-[702px] md:max-w-[500px]"
          dangerouslySetInnerHTML={{ __html: jobOpening?.description }}
        ></div>

        <button
          onClick={handleState}
          className="bg-darkGrey hover:bg-beige hover:text-darkGrey transition-all duration-300 ease w-full mt-4 md:my-0 md:h-50 h-10 text-white md:w-[150px] rounded-full"
        >
          Apply
        </button>
      </div>
      <div className="flex flex-col">
        <div className="flex flex-col gap-4 border-darkGrey/50 border-b-[0.5px] py-8">
          <h3 className="lg:text-lg text-base text-darkGrey/70 ">
            Responsibilities
          </h3>
          <div
            className={listClass}
            dangerouslySetInnerHTML={{ __html: jobOpening?.responsibilities }}
          ></div>
        </div>

        <div className="flex flex-col gap-4 py-8">
          <h3 className="lg:text-lg text-base text-darkGrey/70 ">Skills</h3>
          <div
            className={listClass}
            dangerouslySetInnerHTML={{ __html: jobOpening?.skills }}
          ></div>
        </div>
      </div>
    </div>
  );
}
